import React from 'react';
import { IonSkeletonText } from '@ionic/react';

interface PlayerRankingSkeletonProps {
  itemCount?: number;
}

const PlayerRankingSkeleton: React.FC<PlayerRankingSkeletonProps> = ({ itemCount = 15 }) => {
  return (
    <div className="p-2">
      {/* Tab filters skeleton */}
      <div className="mt-5 flex items-center gap-2">
        <div className="flex gap-2 overflow-x-auto no-scrollbar">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="h-[34px] px-[11.5px] shrink-0 rounded-[31.05px] flex items-center justify-center">
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '80px', 
                  height: '34px',
                  '--background-rgb': '255, 255, 255',
                  opacity: '1',
                  borderRadius: '31.05px'
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Search bar skeleton */}
      <div className="mt-3">
        <div className="relative flex items-center">
          <IonSkeletonText 
            animated 
            style={{ 
              width: '100%', 
              height: '40px',
              '--background-rgb': '255, 255, 255',
              opacity: '1',
              borderRadius: '10px'
            }}
          />
        </div>
      </div>

      {/* Position filters skeleton */}
      <div className="mt-3 flex gap-2 overflow-x-auto no-scrollbar">
        {['All', 'QB', 'RB', 'WR', 'TE'].map((_, index) => (
          <div key={index} className="w-[50px] h-[28px] shrink-0 rounded-[8px] flex items-center justify-center">
            <IonSkeletonText 
              animated 
              style={{ 
                width: '50px', 
                height: '28px',
                '--background-rgb': '255, 255, 255',
                opacity: '1',
                borderRadius: '8px'
              }}
            />
          </div>
        ))}
      </div>

      {/* Table header skeleton */}
      <div className="mt-6 px-2">
        <div className="flex items-center justify-between border-b border-white/10 pb-2">
          <IonSkeletonText 
            animated 
            style={{ 
              width: '40px', 
              height: '16px',
              '--background-rgb': '255, 255, 255',
              opacity: '1'
            }}
          />
          <IonSkeletonText 
            animated 
            style={{ 
              width: '80px', 
              height: '16px',
              '--background-rgb': '255, 255, 255',
              opacity: '1'
            }}
          />
          <IonSkeletonText 
            animated 
            style={{ 
              width: '60px', 
              height: '16px',
              '--background-rgb': '255, 255, 255',
              opacity: '1'
            }}
          />
          <IonSkeletonText 
            animated 
            style={{ 
              width: '50px', 
              height: '16px',
              '--background-rgb': '255, 255, 255',
              opacity: '1'
            }}
          />
        </div>
      </div>

      {/* Table rows skeleton */}
      <div className="mt-2">
        {[...Array(itemCount)].map((_, index) => (
          <div key={index} className="flex items-center justify-between px-2 py-3 border-b border-white/5">
            {/* Rank */}
            <div className="w-[40px]">
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '20px', 
                  height: '16px',
                  '--background-rgb': '255, 255, 255',
                  opacity: '1'
                }}
              />
            </div>
            
            {/* Player info */}
            <div className="flex items-center gap-2 flex-1">
              {/* Player image */}
              <div className="w-[32px] h-[32px] rounded-full">
                <IonSkeletonText 
                  animated 
                  style={{ 
                    width: '32px', 
                    height: '32px',
                    '--background-rgb': '255, 255, 255',
                    opacity: '1',
                    borderRadius: '50%'
                  }}
                />
              </div>
              
              {/* Player name and team */}
              <div className="flex-1">
                <IonSkeletonText 
                  animated 
                  style={{ 
                    width: '100px', 
                    height: '14px',
                    '--background-rgb': '255, 255, 255',
                    opacity: '1',
                    marginBottom: '4px'
                  }}
                />
                <IonSkeletonText 
                  animated 
                  style={{ 
                    width: '60px', 
                    height: '12px',
                    '--background-rgb': '255, 255, 255',
                    opacity: '1'
                  }}
                />
              </div>
            </div>
            
            {/* Stats columns */}
            <div className="w-[60px] text-center">
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '40px', 
                  height: '16px',
                  '--background-rgb': '255, 255, 255',
                  opacity: '0.1'
                }}
              />
            </div>
            
            <div className="w-[50px] text-center">
              <IonSkeletonText 
                animated 
                style={{ 
                  width: '35px', 
                  height: '16px',
                  '--background-rgb': '255, 255, 255',
                  opacity: '0.1'
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlayerRankingSkeleton; 